// Sauvegarde / restauration complète au format JSON versionné et daté.

// Version du format (incrémentée si changement de schéma).
export const BACKUP_VERSION = 1;

// Données brutes exportées, par collection.
export interface BackupData {
  profile: Record<string, unknown> | null;
  weights: Record<string, unknown>[];
  milestones: Record<string, unknown>[];
  foods: Record<string, unknown>[];
  consumptions: Record<string, unknown>[];
  /** Optionnels : absents des sauvegardes antérieures (rétro-compat, normalisés en []). */
  water: Record<string, unknown>[];
  exercises: Record<string, unknown>[];
  favorites: Record<string, unknown>[];
}

interface BackupFile {
  version: number;
  exportedAt: string;
  data: BackupData;
}

const ARRAY_KEYS: (keyof BackupData)[] = ['weights', 'milestones', 'foods', 'consumptions'];

export function serializeBackup(data: BackupData, now: Date = new Date()): string {
  const file: BackupFile = { version: BACKUP_VERSION, exportedAt: now.toISOString(), data };
  return JSON.stringify(file, null, 2);
}

// Parse et valide une sauvegarde ; lève si version incompatible ou structure invalide.
export function parseBackup(text: string): BackupData {
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    throw new Error('Fichier JSON invalide.');
  }
  if (typeof parsed !== 'object' || parsed === null) {
    throw new Error('Sauvegarde invalide : objet attendu.');
  }
  const file = parsed as Partial<BackupFile>;
  if (file.version !== BACKUP_VERSION) {
    throw new Error(`Version de sauvegarde incompatible (attendu ${BACKUP_VERSION}).`);
  }
  const data = file.data;
  if (typeof data !== 'object' || data === null) {
    throw new Error('Sauvegarde invalide : bloc "data" manquant.');
  }
  for (const key of ARRAY_KEYS) {
    if (!Array.isArray((data as BackupData)[key])) {
      throw new Error(`Sauvegarde invalide : "${key}" doit être une liste.`);
    }
  }
  // Clés additives rétro-compatibles → normalisées en [] si absentes.
  const d = data as BackupData;
  d.water = Array.isArray(d.water) ? d.water : [];
  d.exercises = Array.isArray(d.exercises) ? d.exercises : [];
  d.favorites = Array.isArray(d.favorites) ? d.favorites : [];
  return d;
}
